<template>
  <div id="container">
    <div id="main">

      <header class="home-header wrap">
        <nav-bar/>
      </header>


      <div class="people" v-if="activeIndex=='faculty'">
        <div class="big-title">
          <span style="font-size: 25px">Students </span>
        </div>

        <div class="big-title" style="font-size: 25px;margin-top: 30px">
          <span type="text">在读博士</span>
        </div>

        <el-divider></el-divider>

        <div>
          <el-row type="flex" class="el-row">
            <el-col :span=4 v-for="object in findDoc(studentsList)" :key="object.id">
              <el-card :body-style="{ padding: '0px' }" >
                <img :src="'http://' + object.picurl" alt="picture missed" class="image"/>
                <!--                <img :src="'http://123.57.255.174:8080/pic/yaochang.jpg'" alt="picture missed" class="image"/>-->
                <div style="padding: 10px;">
                  <span class="small-title" style="font-size: 20px">{{ object.name }}</span>
                  <div class="bottom clearfix">
                    <span style="font-size: 10px;">{{ object.grade }}</span>
                    <!--                    <el-button type="text" class="button" style="font-size: 5px">Show More</el-button>-->
                    <template>
                      <!--                      <el-button type="text" class="button" @click="dialogTableVisible = true" style="font-size: 5px">More</el-button>-->
                      <el-tooltip placement="bottom">
                        <div slot="content">
                          姓名：{{ object.name }}
                          <br/>
                          年级：{{ object.grade }}
                          <br/>
                          email：{{ object.email }}
                          <br/>
                          方向：{{ changeDir(object.reaserch_type) }}
                        </div>
                        <el-button type="text" class="button" style="font-size: 5px">More</el-button>
                      </el-tooltip>
                    </template>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>

        <div class="big-title" style="font-size: 25px;margin-top: 30px">
          <span type="text">在读硕士</span>
        </div>

        <el-divider></el-divider>

        <div>
          <el-row type="flex" class="el-row">
            <el-col :span=4 v-for="object in findMas(studentsList)" :key="object.id">
              <el-card :body-style="{ padding: '0px' }" >
                <img :src="'http://' + object.picurl" alt="picture missed" class="image"/>
                <!--                <img :src="'http://123.57.255.174:8080/pic/yaochang.jpg'" alt="picture missed" class="image"/>-->
                <div style="padding: 10px;">
                  <span class="small-title" style="font-size: 20px">{{ object.name
                    }}</span>
                  <div class="bottom clearfix">
                    <span style="font-size: 10px;">{{ object.grade }}</span>

<!--                    <div v-if="object.grade === '研三'" style="margin-top:12px; border-top:1px dashed #eee; padding:12px 0;">-->
<!--                      <div style="color:#C00000; font-size:12px; line-height: 1.2;">-->
<!--                        <div v-if="object.next_plan !== ''" style="margin-right: 6px;">-->
<!--                          {{ "就业去向：" + object.next_plan }}<br><br>-->
<!--                        </div>-->

<!--                        <div v-if="object.paper !== null"  style="margin-right: 6px;">-->
<!--                          {{ "科研成果：" + object.paper }}<br><br>-->
<!--                        </div>-->

<!--                        <div v-if="object.intern !== null" style="margin-right: 6px;">-->
<!--                          {{ "实习情况：" + object.intern + "个月" }}-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->

                    <!--                    <el-button type="text" class="button" style="font-size: 5px">Show More</el-button>-->
                    <template>
                      <!--                      <el-button type="text" class="button" @click="dialogTableVisible = true" style="font-size: 5px">More</el-button>-->
                      <el-tooltip placement="bottom">
                        <div slot="content">
                          姓名：{{ object.name }}
                          <br/>
                          年级：{{ object.grade }}
                          <br/>
                          email：{{ object.email }}
                          <br/>
                          方向：{{ changeDir(object.reaserch_type) }}
                        </div>
                        <el-button type="text" class="button" style="font-size: 5px">More</el-button>
                      </el-tooltip>
                    </template>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>

        <div class="big-title" style="font-size: 25px;margin-top: 30px">
          <span type="text">博士毕业生</span>
        </div>

        <el-divider></el-divider>

        <div>
          <el-row type="flex" class="el-row">
            <el-col :span=4 v-for="object in findDocGra(studentsList)" :key="object.id">
              <el-card :body-style="{ padding: '0px' }" >
                <img :src="'http://' + object.picurl" alt="picture missed" class="image"/>
                <!--                <img :src="'http://123.57.255.174:8080/pic/yaochang.jpg'" alt="picture missed" class="image"/>-->
                <div style="padding: 10px;">
                  <span class="small-title" style="font-size: 20px">{{ object.name
                    }}</span>
                  <div class="bottom clearfix">
                    <span style="font-size: 10px;">{{ object.grade.substr(0, 5) }}</span>

                    <!-- 就业模拟区块 -->
                    <div style="margin-top:12px; border-top:1px dashed #eee; padding:12px 0;">
                      <div style="color:#C00000; font-size:12px; line-height: 1.2;">
                        <div v-if="object.next_plan !== ''" style="margin-right: 6px;">
                          {{ "就业去向：" + object.next_plan }}<br><br>
                        </div>

                        <div v-if="object.paper !== null"  style="margin-right: 6px;">
                          {{ "科研成果：" + object.paper}} <br><br>
                        </div>

                        <div v-if="object.intern !== null" style="margin-right: 6px;">
                          {{ "实习情况：有实习经历"  }}
                        </div>

                      </div>
                    </div>

                    <template>
                      <!--                      <el-button type="text" class="button" @click="dialogTableVisible = true" style="font-size: 5px">More</el-button>-->
                      <el-tooltip placement="bottom">
                        <div slot="content">
                          姓名：{{ object.name }}
                          <br/>
                          年级：{{ object.grade.substr(0, 5) }}
                          <br/>
                          email：{{ object.email }}
                          <br/>
                          方向：{{ changeDir(object.reaserch_type) }}
                        </div>
                        <el-button type="text" class="button" style="font-size: 5px">More</el-button>
                      </el-tooltip>
                    </template>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>


        <div class="big-title" style="font-size: 25px;margin-top: 30px">
          <span type="text">硕士毕业生</span>
        </div>

        <el-divider></el-divider>

        <div>
          <el-row type="flex" class="el-row">
            <el-col :span=4 v-for="object in findMasGra(studentsList)" :key="object.id">
              <el-card :body-style="{ padding: '0px' }" >
                <img :src="'http://' + object.picurl" alt="picture missed" class="image"/>
                <!--                <img :src="'http://123.57.255.174:8080/pic/yaochang.jpg'" alt="picture missed" class="image"/>-->
                <div style="padding: 10px;">
                  <span class="small-title" style="font-size: 20px">{{ object.name
                    }}</span>
                  <div class="bottom clearfix">
                    <span style="font-size: 10px;">{{ object.grade.substr(0, 5) }}</span>
                    <!--                    <el-button type="text" class="button" style="font-size: 5px">Show More</el-button>-->

                    <!--                    &lt;!&ndash; 新增就业信息模块 &ndash;&gt;-->
                    <!--                    <div style="margin-top: 8px; border-top: 1px solid #eee; padding-top: 6px;">-->
                    <!--                      <div style="font-size: 12px; color: #666;">-->
                    <!--                        <div v-if="object.employment" style="margin-bottom: 4px;">-->
                    <!--                          <i class="el-icon-office-building" style="margin-right: 5px;"></i>-->
                    <!--                          去向：{{ object.employment.company }}-->
                    <!--                        </div>-->
                    <!--                      </div>-->
                    <!--                    </div>-->

                    <!-- 就业模拟区块 -->
                    <div style="margin-top:12px; border-top:1px dashed #eee; padding:12px 0;">
                      <div style="color:#C00000; font-size:12px; line-height: 1.2;">
                        <div v-if="object.next_plan !== ''" style="margin-right: 6px;">
                          {{ "就业去向：" + object.next_plan }}<br><br>
                        </div>

                        <div v-if="object.paper !== null"  style="margin-right: 6px;">
                          {{ "科研成果：" + object.paper}} <br><br>
                        </div>

                        <div v-if="object.intern !== null" style="margin-right: 6px;">
                          {{ "实习情况：有实习经历"  }}
                        </div>

                      </div>
                    </div>

                    <template>
                      <!--                      <el-button type="text" class="button" @click="dialogTableVisible = true" style="font-size: 5px">More</el-button>-->
                      <el-tooltip placement="bottom">
                        <div slot="content">
                          姓名：{{ object.name }}
                          <br/>
                          年级：{{ object.grade.substr(0, 5) }}
                          <br/>
                          email：{{ object.email }}
                          <br/>
                          方向：{{ changeDir(object.reaserch_type) }}
                        </div>
                        <el-button type="text" class="button" style="font-size: 5px">More</el-button>
                      </el-tooltip>
                    </template>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>

      </div>
    </div>
    <footerInfo/>
  </div>
</template>


<script>
import navBar from '@/components/NavBar'
import footerInfo from '@/components/FooterInfo'
import 'element-ui/lib/theme-chalk/base.css'
import {Toast} from "vant";
import {getStudentsInfo} from '@/service/students'

export default {
  name: "people",
  props: [],
  data() {
    return {
      self_applicationList: [],
      studentsList: [],

      dialogTableVisible: false,
    // {
    //   id: 1,
    //   title: "Professor",
    //   name: "Tian He",
    //   photo: require("../assets/people/hetian.jpg"),
    //   url: "https://www-users.cse.umn.edu/~tianhe/",
    //   desc:
    //   "IEEE/ACM Fellow<br/>" +
    //   "Director, Smart Internet of Things Research Center, Southeast University<br/><br/>" +
    //   "<b>Research Interests:</b> Artificial Intelligence, Wireless Coexistence, Posture/Behavior Estimation, " +
    //   "Social Interaction Monitoring, " +
    //   "Large-Scale Intelligent Transportation Systems (road network efficiency and safety), " +
    //   "Rechargeable Sensor Systems/Battery Array Management/Safe Charging.<br/><br/>" +
    //   "<b>Email:</b> tianhe@seu.edu.cn"
    // },
    //
    // {
    //   "id": 1,
    //   "picurl": "123.57.255.174:8080/pic/yaochang.jpg",
    //   "grade": "研一",
    //   "email": "yaochang_liu@foxmail.com",
    //   "name": "刘尧畅",
    //   "reaserch_type" : 0
    // },
      activeIndex: "faculty"
    };
  },
  components: {
    navBar,
    footerInfo,
  },
  mounted() {
    this.init()
  },
  methods: {
    goToUrl(url) {
      window.location.href = url;
    },
    // open() {
    //   this.$alert('这是一段内容', '标题名称', {
    //     confirmButtonText: '确定',
    //     callback: action => {
    //       this.$message({
    //         type: 'info',
    //         message: `action: ${ action }`
    //       });
    //     }
    //   });
    changeDir(num) {
      if(num == "0"){
        return "大数据方向";
      } else if (num == "1") {
        return "物联网方向";
      } else if (num == "2") {
        return "感知方向";
      } else if (num == "4") {
        return "未知";
      }
    },

    isDoc(src){
      return src.startsWith('博');
    },

    isMas(src){
      return src.startsWith('研');
    },

    isMasGra(src){
        return src.endsWith('硕士');
    },

    isDocGra(src) {
        return src.endsWith('博士');
    },

    findDoc(source) {
      let temp = [];
      for (let i = 0; i < source.length; i++) {
        if (this.isDoc(source[i].grade)) {
          temp.push(source[i])
        }
      }

      return Array.from(temp)
    },

    findMas(source) {
      let temp = [];
      for (let i = 0; i < source.length; i++) {
        if (this.isMas(source[i].grade)) {
          temp.push(source[i])
        }
      }
      return Array.from(temp)
    },

    findMasGra(source) {
      let temp = [];
      for (let i = 0; i < source.length; i++) {
        if (this.isMasGra(source[i].grade)) {
          temp.push(source[i])
        }
      }

      temp.sort((a, b) => {
        return parseInt(b.grade.substring(0, 4)) - parseInt(a.grade.substring(0, 4))
      })

      return Array.from(temp)
    },

    findDocGra(source) {
      let temp = [];
      for (let i = 0; i < source.length; i++) {
        if (this.isDocGra(source[i].grade)) {
          temp.push(source[i])
        }
      }

      temp.sort((a, b) => {
        return parseInt(b.grade.substring(0, 4)) - parseInt(a.grade.substring(0, 4))
      })

      return Array.from(temp)
    },

    async init() {
      Toast.loading({message: '加载中...', forbidClick: true});
      const {data: slist} = await getStudentsInfo()
      this.studentsList = slist.Students;
      Toast.clear()
    },
  },

};
</script>


<style lang="less" scoped>
@import '../common/style/mixin';
@import '../common/style/text';

#container {
  position: relative;
}

#main {
  padding-bottom: 150px;
}

.home-header {
  position: fixed;
  left: 0;
  top: 0;
  .wh(100%, 40px);
  .fj();
  line-height: 40px;
  padding: 0 15px;
  .boxSizing();
  font-size: 12px;
  color: #fff;
  z-index: 10000;
  align-items: center;
  display: flex;
  box-shadow: 0 0 3px 0 @theme-color;

}

.people {
  margin: auto;
  width: 72%;
  margin-top: 60px;
  padding-bottom: 15px;
}

.el-row {
  margin-top: 10px;
}

.el-divider--horizontal {
  margin: 8px 0;
  background: 0 0;
  border-top: 2px dashed rgba(56, 149, 191, 0.25);
}

.el-card {
  margin: 5px;
  width: 90%;
  border: 0ch;
}


//.image {
//  width: 90%;
//  display: block;
//}

.bottom {
  margin-top: 5px;
  line-height: 5px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  height: 180px;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.el-row{
  display: flex;
  flex-wrap: wrap;
}


</style>
